export const USER_SIGNIN = 'USER_SIGNIN';
export const USER_SIGNOUT = 'USER_SIGNOUT';
export const ERROR='ERROR';
export const HIDE_ERROR='HIDE_ERROR';
export const CURRENT_USER = 'CURRENT_USER';
export const DUMP_CURRENT_USER = 'DUMP_CURRENT_USER';

